import React, { useRef } from 'react';
import axios from 'axios';
import { setLoginSession } from '../utils/sessionAuth';

let apiUrl = '//api.mosuseoul.com';

if (process.env.NODE_ENV === 'production') {
  apiUrl = '//api.mosuseoul.com';
}

const Login = () => {
  const formRef = useRef();

  const loginProcess = async () => {
    try {
      const data = {
        id: formRef.current.id.value,
        password: formRef.current.password.value,
      };

      axios
        .post(`${apiUrl}/api/admin/login`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          console.log(res);

          if (res?.status === 200) {
            // 새로운 세션 설정 함수 사용
            const sessionKey = setLoginSession();
            console.log('Login successful, session key:', sessionKey);
            
            document.location.href = '/adm';
          } else {
            console.log('login in Fail');
            alert('Login is Failed');
          }
        })
        .catch(() => {
          console.log('login in Fail');
          alert('Login is Failed');
        });
    } catch (e) {
      console.log(e);
      return e;
    }
  };
  
  const login = async (e) => {
    e.preventDefault();
    await loginProcess();
  };

  return (
    <>
      <section className="resume-section login" id="admin-login">
        <div className="resume-section-content login">
          <h4>MOSU Admin Login</h4>

          <form ref={formRef} onSubmit={login}>
            <input type="text" name="id" placeholder="id" required />
            <input
              type="password"
              name="password"
              placeholder="password"
              required
            />
            <button type="submit" value={'Login'} className={'btn-login'}>
              Login
            </button>
          </form>
        </div>
      </section>
    </>
  );
};

export default Login;
